import {
  catalog,
  order,
  productDetail,
  search,
  sections,
  showcases,
  user,
  utilities,
} from 'core/use-cases';
import { GENERIC_ERROR_ID } from './error-id';

export function hasNotification(action: utilities.ActionFailure, pathname: string) {
  const actionErrorList = [
    catalog.actions.catalogFetch.failure.type,
    order.actions.orderFetch.failure.type,
    showcases.actions.showcasesFetch.failure.type,
    user.actions.creditFetch.failure.type,
    user.actions.userFetch.failure.type,
    sections.actions.sectionsFetch.failure.type,
    search.actions.searchFetch.failure.type,
    productDetail.actions.productDetailFetch.failure.type,
  ];

  const isErrorFech = actionErrorList.some((elemento) => action.type.includes(elemento));

  const isErrorPrismicNoResponse = action.error?.message === 'No response';
  const genericError = action.error?.response?.errorId === GENERIC_ERROR_ID.INTERNAL_SERVER_ERROR;

  const conditional = ['40', '50', 'confirmation', 'process'];
  const hasRoute = conditional.some((elemento) => pathname.includes(elemento));

  return isErrorPrismicNoResponse || hasRoute || genericError || isErrorFech;
}
